module.exports = __webpack_public_path__ + "static/media/circle.2811b8ea.svg";